import React from 'react';

const OrderDetails = (props) => {
  const { Translations, currentOrder } = props;
  return (
    <div className="order-info py-5 mb-7 mb-lg-9">
      <div className="order-info-row mb-3">
        <span className="heading5">{Translations.OrderDetailsOrderNumberLabel}: </span>
        <span className="paragraph">{currentOrder.OrderConfirmationId}</span>
      </div>
      <div className="order-info-row">
        <span className="heading5">{Translations.OrderDateLabel}: </span>
        <span className="paragraph">{currentOrder.OrderDate}</span>
      </div>
    </div>
  );
};

export default OrderDetails;
